import React, { useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
  Box
} from '@mui/material'
import { useStyles } from '../style'

const PersonalizationSkippedModal = ({ open, onClose, onReturnToQuestionnaire }) => {
  const classes = useStyles()
  const [dontShowAgain, setDontShowAgain] = useState(false)

  const handleClose = () => {
    onClose(dontShowAgain)
  }

  const handleReturnToQuestionnaire = () => {
    onReturnToQuestionnaire()
  }

  const handleCheckboxChange = (event) => {
    setDontShowAgain(event.target.checked)
  }

  return (
    <Dialog
      open={open}
      onClose={() => handleReturnToQuestionnaire()}
      maxWidth='sm'
      fullWidth
      className={classes.skipModalDialog}
      PaperProps={{
        className: classes.skipModalPaper
      }}
      data-test='personalization-skipped-modal'
      aria-labelledby='skip-modal-title'
      aria-describedby='skip-modal-description'
    >
      <DialogContent className={classes.skipModalContent} data-test='modal-content'>
        <Typography
          id='skip-modal-title'
          variant='h6'
          className={classes.skipModalTitle}
          data-test='modal-title'
        >
          Personalization skipped
        </Typography>

        <Typography
          id='skip-modal-description'
          variant='body1'
          className={classes.skipModalDescription}
          data-test='modal-description'
        >
          Completing this questionnaire helps us deliver the most relevant content. You can finish it later in your profile.
        </Typography>

        <Box className={classes.skipModalCheckboxContainer} data-test='checkbox-container'>
          <FormControlLabel
            control={
              <Checkbox
                checked={dontShowAgain}
                onChange={handleCheckboxChange}
                className={classes.skipModalCheckbox}
                data-test='dont-show-again-checkbox'
                aria-label="Don't show onboarding again"
              />
            }
            label="Don't show onboarding again"
            className={classes.skipModalCheckboxLabel}
            data-test='dont-show-again-label'
          />
        </Box>
      </DialogContent>

      <DialogActions className={classes.skipModalActions} data-test='modal-actions'>
        <Button
          onClick={handleReturnToQuestionnaire}
          className={classes.skipModalReturnButton}
          data-test='return-to-questionnaire'
          aria-label='Return to questionnaire'
        >
          Return to questionnaire
        </Button>

        <Button
          onClick={handleClose}
          variant='outlined'
          className={classes.skipModalCloseButton}
          data-test='close-modal'
          aria-label='Close modal and skip questionnaire'
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default PersonalizationSkippedModal
